import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=294e9e8f&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e9e8f",
  null
  
)

export default component.exports